import applicationDocsMapper from '@/shared/mappers/customers/finance-applications/application-docs.mapper';
import { PurchasesModel } from '@/shared/models/purchases.model';
import { getLocalizedValue } from '@/shared/services/helpers/format-display-label/format-display-label';
import { PurchaseUiModel } from '@/shared/ui-models/purchase.ui-model';

function mapToModel(purchase: PurchaseUiModel): PurchasesModel {
  return {
    ...(purchase.id && { id: purchase.id }),
    ...(purchase.customer?.id && { userId: purchase.customer.id }),
    ...(purchase.merchant?.id && { merchantId: purchase.merchant.id }),
    ...(purchase.product?.id && { productId: purchase.product.id }),
    ...(purchase.customerApplication?.id && {
      applicationId: purchase.customerApplication.id
    }),
    ...(purchase.productType && { productType: purchase.productType }),
    ...(purchase.paymentMethod && { paymentMethod: purchase.paymentMethod }),
    ...(purchase.financeOfficer?.id && { financeOfficerId: purchase.financeOfficer.id }),
    ...(purchase.status && { status: purchase.status }),
    ...(purchase.supplierType && { supplierType: purchase.supplierType }),
    ...(purchase.supplierName && { supplierName: purchase.supplierName }),
    ...(purchase.autoSourceAgent?.id && { autoSourceAgentId: purchase.autoSourceAgent.id }),
    ...(purchase.autoProfitMargin && { autoProfitMargin: +purchase.autoProfitMargin })
  };
}

function mapToUi(purchase: PurchasesModel): PurchaseUiModel {
  return {
    id: purchase.id,
    customer: { id: purchase.user?.id ?? '', label: purchase.user?.name ?? '' },
    productType: purchase.productType,
    financeOfficer: {
      id: purchase.financeOfficer?.id ?? '',
      label: purchase.financeOfficer?.name ?? ''
    },
    paymentMethod: purchase.paymentMethod,
    status: purchase.status,
    createdAt: purchase.createdAt,
    createdBy: { name: purchase.createdByUser?.name ?? '' },
    updatedAt: purchase.updatedAt,
    merchant: {
      id: purchase.merchant?.id ?? '',
      label: getLocalizedValue(purchase.merchant?.companyName),
      imageUrl: purchase.merchant?.url ?? ''
    },
    merchantDetails: purchase.merchant,
    product: {
      id: purchase.product?.id ?? '',
      label: `${getLocalizedValue(purchase.product?.carBrand?.name)} - ${getLocalizedValue(
        purchase.product?.carModel
      )} (${purchase.product?.carChassis ?? ''})`
    },
    productDetails: purchase.product,
    hasApplication: purchase.applicationId ? 'true' : 'false',
    applicationId: purchase.applicationId,
    customerApplication: {
      id: purchase.applicationId ?? '',
      label: `${purchase.application?.shortId} - ${purchase.application?.customer?.personalData?.idNameArabic}`,
      subLabel: [
        `${getLocalizedValue(
          purchase.application?.financialMerchant?.companyName
        )} / ${getLocalizedValue(
          purchase.application?.financialProduct?.productName
        )} / ${getLocalizedValue(
          purchase.application?.product?.carBrand?.name
        )} - ${getLocalizedValue(purchase.application?.product?.carModel)}`
      ]
    },
    application: {
      id: purchase.applicationId ?? '',
      shortId: purchase.application?.shortId,
      agent: purchase.application?.agent?.name ?? '',
      merchantAgent: purchase.application?.merchantAgent?.name ?? '',
      lastUpdatedByUser: purchase.application?.lastUpdatedByUser?.name ?? '',
      lastUpdatedAt: purchase.application?.lastUpdatedAt,
      financialMerchant: getLocalizedValue(purchase.application?.financialMerchant?.companyName),
      financialProduct: getLocalizedValue(purchase.application?.financialProduct?.productName),
      merchant: getLocalizedValue(purchase.application?.merchant?.companyName),
      product: `${getLocalizedValue(
        purchase.application?.product?.carBrand?.name
      )} - ${getLocalizedValue(purchase.application?.product?.carModel)}`,
      status: purchase.application?.status
    },
    applicationDocuments: purchase.application?.applicationAttachments
      ? applicationDocsMapper.mapToUI(purchase.application?.applicationAttachments)
      : {},
    supplierType: purchase.supplierType,
    supplierName: purchase.supplierName,
    autoProfitMargin: purchase.autoProfitMargin,
    autoSourceAgent: {
      id: purchase.autoSourceAgentId ?? '',
      label: purchase.autoSourceAgent?.name ?? ''
    }
  };
}

const purchasesMapper = { mapToModel, mapToUi };

export default purchasesMapper;
